import React from 'react'
import BlockUi from 'react-block-ui';

let _blockRef;
let _modalRef;

export const hookmodal = (ref) => {
    _modalRef = ref;
}

export const hookref = (ref) => {
    _blockRef = ref;
}

export const block = () => {
    _blockRef && _blockRef.update(true);
    _modalRef && _modalRef.update(true);
}

export const unblock = () => {
    _blockRef && _blockRef.update(false);
    _modalRef && _modalRef.update(false);
}

export class Block extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            blocking: this.props.blocking
        };
    }

    update(value) {
        this.setState({ blocking: value });
    }

    render() {
        return (
            <BlockUi tag="div" blocking={this.state.blocking}>
                {this.props.children}
            </BlockUi>
        )
    }
}



// WEBPACK FOOTER //
// ./src/fw/globals/Block.js